import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { NotifyOptionComponent } from './notify-option.component';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-policy-period-option',
  imports: [SelectOptionComponent, NotifyOptionComponent],
  template: `
    <app-select-option
      [label]="label"
      [control]="control"
      [optionValue]="null"
      [items]="alerts.percentItems"
      [multiple]="false"
      [filter]="false"
      [virtualScroll]="false"
      selectLabel="Percentage"
      [helpText]="helpText"
    />

    <app-select-option
      label="Evaluate financials"
      [control]="financialControl"
      [optionValue]="null"
      [items]="alerts.financialItems"
      [multiple]="false"
      [filter]="false"
      [virtualScroll]="false"
      selectLabel="Evaluate"
    />

    <app-notify-option [control]="notifyControl" />
  `,
  styles: ``,
})
export class PolicyPeriodOptionComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  label: string;

  @Input()
  control: FormControl<any>;

  @Input()
  financialControl: FormControl<any>;

  @Input()
  notifyControl: FormControl<number>;

  @Input()
  policyCodeType: PolicyCodeType = 'Claim';

  @Input()
  helpText: string;

  async ngOnInit() {
    await this.addValidators();
  }

  async addValidators() {
    if (this.policyCodeType === 'Claim') {
      this.control.addValidators([Validators.required]);
      if (this.control.value == null) {
        this.control.setValue(
          this.alerts.find(this.alerts.percentItems, 50),
        );
      }

      this.financialControl.addValidators([Validators.required]);
      if (this.financialControl.value == null) {
        this.financialControl.setValue(
          this.alerts.find(this.alerts.financialItems, 'incurred'),
        );
      }

      if (this.notifyControl.value == null) {
        this.notifyControl.setValue(1);
      }
      this.helpText =
        'When the deductible/retention applies at the event level, this alert triggers based on event financials. Results appear at the claim level. Use the event number in the results to identify all related claims.';
    } else {
      this.control.addValidators([Validators.required]);
      if (this.control.value == null) {
        this.control.setValue(
          this.alerts.find(this.alerts.percentItems, 50),
        );
      }

      this.financialControl.addValidators([Validators.required]);
      if (this.financialControl.value == null) {
        this.financialControl.setValue(
          this.alerts.find(this.alerts.financialItems, 'incurred'),
        );
      }

      if (this.notifyControl.value == null) {
        this.notifyControl.setValue(1);
      }
      this.helpText =
        'This alert monitors event-level financials but displays results at the claim level. Use the Event Number in the results to identify all related claims in an event.';
    }
  }
}

export type PolicyCodeType = 'Claim' | 'Event';
